import { render, staticRenderFns } from "./Compression_Molding.vue?vue&type=template&id=bcd5e39c&scoped=true"
import script from "./Compression_Molding.vue?vue&type=script&lang=js"
export * from "./Compression_Molding.vue?vue&type=script&lang=js"
import style0 from "./Compression_Molding.vue?vue&type=style&index=0&id=bcd5e39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd5e39c",
  null
  
)

export default component.exports